export function hasShippingTrackingEvents(
  tracking: unknown[] | null | undefined
): boolean {
  return Array.isArray(tracking) && tracking.length > 0;
}

export function shouldUseInvoiceTrackingFallback(
  pedidoV: string | number | null | undefined,
  tracking: unknown[] | null | undefined,
  invoiceNumber: string | number | null | undefined
): boolean {
  return (!pedidoV || !tracking?.length) && Boolean(invoiceNumber);
}
